<template>
  <div class="article col px-0 contact d-flex flex-column">
    <div class="content-title">
      <div class="media">
        <div class="media-body">
          <h1>
            {{ $t(`feature.article.category.${articleType}`) }}
          </h1>
          <breadcrumbs
            v-if="showBreadcrumbs"
            :labels="breadcrumbsLabels"
          ></breadcrumbs>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import Breadcrumbs from "./Breadcrumbs";

export default {
  components: {
    Breadcrumbs
  },
  data() {
    return {
      breadcrumbsLabels: []
    };
  },
  computed: {
    articleId() {
      return this.$route.params.articleId;
    },
    articleStatus() {
      return (
        this.$route.params.articleStatus ||
        this.$store.state.currentArticleStatus ||
        "draft"
      );
    },
    articleType() {
      if (this.$route.name === "BannerList") {
        return "banner";
      }

      return this.$route.params.articleType || "news";
    },
    showBreadcrumbs() {
      return this.breadcrumbsLabels.length > 1;
    }
  },
  watch: {
    $route(to) {
      if (!to.params.articleType) {
        this.defaultRoute();
      } else {
        this.$store.state.currentArticleType = to.params.articleType;
      }

      this.setBreadcrumbs(this.articleType, to);
    }
  },
  created() {
    if (!this.articleType) {
      this.articleType = this.$store.state.currentArticleType;
      this.defaultRoute();
    }

    this.setBreadcrumbs(this.articleType, this.$route);
  },
  methods: {
    defaultRoute() {
      this.$router.push({
        name: "ArticleListStatus",
        params: {
          articleType: this.$store.state.currentArticleType || "news",
          articleStatus: this.$store.state.currentArticleStatus || "draft"
        }
      });
    },
    setBreadcrumbs(articleType, to = null) {
      const labels = [];

      labels[0] = "ข่าวทั้งหมด";

      if (articleType === "banner") {
        this.breadcrumbsLabels = labels;
        return;
      }

      if (this.articleStatus) {
        labels[1] = this.$t(`feature.article.tabs.${this.articleStatus}`);
      } else if (this.articleId) {
        labels[1] = this.$t("feature.article.tabs.edit");
      } else if (to && to.name === "ArticleCreate") {
        labels[1] = this.$t("feature.article.tabs.create");
      }

      this.breadcrumbsLabels = labels;
    }
  }
};
</script>

<style></style>
